import React, { useState, useEffect } from 'react';
import classnames from 'classnames';
import { useSelector, useDispatch } from 'react-redux';
import DropdownMultiple from './DropdownMultiple';
import { addNotificationSetting } from '../actions/apiNotifications';

function NotificationCheckbox(props) {
    const [value, setValue] = useState(props.value || '');
    const [checked, setChecked] = useState(props.checked || '');
    const [dealership, setDealership] = useState(props.dealership);

    const related_installations = useSelector(state => state.settings_dealerships.related_installations);
    const installation = useSelector(state => state.settings_dealerships.installation);

    const dispatch = useDispatch();

    const onChangeChecked = (e) => {
        const errorType = 'addProfilePermissionError';
        const dealership = installation.subdomain;

        const data = {
            department_id: props.department_id,
            value: e.target.checked === true,
            user_id: props.user_id,
            note_type: props.note_type,
            dealership,
        };

        setChecked(e.target.checked);
        dispatch(addNotificationSetting(data, errorType));
    };

    const selectRelatedInstallations = () => {
        const dealerships = dealership || '';
        const selected_dealerships = dealerships.split(',');

        const options = related_installations.map(option => {
            let selected = selected_dealerships.includes(option.subdomain);

            return {
                id: option.id,
                label: option.softname || option.subdomain,
                selected,
                dataid: 0,
                subdomain: option.subdomain,
            };
        });

        if (selected_dealerships.includes('all')) {
            options.push({
                id: 999,
                label: 'all',
                selected: true,
                subdomain: 'all',
            });
        }

        return options;
    };

    let dropdown = '';
    if (related_installations.length > 1 && checked) {
        dropdown = <DropdownMultiple
            {...props}
            titleHelper="Location"
            title="Select location"
            department_id={props.department_id}
            update_type={'notification_settings'}
            data={{ ...props, value: true }}
            checkvalue={checked}
            list={selectRelatedInstallations()}
            dealers={dealership}
        />;
    }

    return (
        <td className="text-center">
            <div className={classnames('form-group', { 'has-danger': props.error })}>
                <span className="switch">
                    <input
                        onChange={onChangeChecked}
                        type="checkbox"
                        name={props.name}
                        data-id={props.department_id}
                        key={`switch_id_${props.department_id}_${props.user_id}_${props.name}`}
                        checked={checked ? 'checked' : ''}
                        className={classnames('text-center', { 'form-control-danger': props.error })}
                        id={`switch_id_${props.department_id}_${props.user_id}_${props.name}`}
                    />
                    <label className="text-capitalize" key={`label_${props.department_id}_${props.user_id}_${props.name}`} htmlFor={`switch_id_${props.department_id}_${props.user_id}_${props.name}`} />
                </span>
            </div>
            <div className="col-md-12">
                {dropdown}
            </div>
        </td>
    );
}

export default NotificationCheckbox;
